import { JSONSchemaType } from 'ajv'

export interface IOrganizationFormData {
  id: string
  snowflakeId?: string
  tempPassword?: string
  federalTaxId: string
  corporateName: string
  tradingName: string
  zipCode: string
  address: string
  number: string
  complement: string
  district: string
  stateId: string
  cityId: string
  cnae: string
  telephone: string
  email: string
  snowflakeAccount: string
  snowflakeUser?: string
  snowflakePassword?: string
  isCustomer: boolean
  blocked: boolean
  isInactive: boolean
}

const OrganizationSchema: JSONSchemaType<IOrganizationFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    snowflakeId: {
      type: 'string',
      nullable: true,
    },
    tempPassword: {
      type: 'string',
      nullable: true,
    },
    federalTaxId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    corporateName: {
      type: 'string',
    },
    tradingName: {
      type: 'string',
    },
    zipCode: {
      type: 'string',
    },
    address: {
      type: 'string',
    },
    number: {
      type: 'string',
    },
    complement: {
      type: 'string',
    },
    district: {
      type: 'string',
    },
    stateId: {
      type: 'string',
    },
    cityId: {
      type: 'string',
    },
    cnae: {
      type: 'string',
    },
    telephone: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    snowflakeAccount: {
      type: 'string',
    },
    snowflakeUser: {
      type: 'string',
      nullable: true,
    },
    snowflakePassword: {
      type: 'string',
      nullable: true,
    },
    isCustomer: {
      type: 'boolean',
      default: false,
    },
    blocked: {
      type: 'boolean',
      default: false,
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['federalTaxId'],
  additionalProperties: false,
}

export default OrganizationSchema
